<template>
    <div v-html="'ShopBasket'"/>
</template>

<script>
export default { name: "ShopBasket" };
</script>